import React from 'react';
import styles from './DragDrop.module.scss';
import PropTypes from 'prop-types';

export const Target = props => {
  let inlineStyle = {};
  if (props.outline) {
    inlineStyle = {
      borderWidth: '2px',
      borderStyle: 'solid',
      borderColor: props.outline
    };
  }

  const getTabIndexValue = () =>
    props.activityType === 'Counters'
      ? -1
      : props.gameStarted && !props.filledSpot && !props.noPieceSelected
      ? '0'
      : '-1';
  return (
    <div
      id={props.divId}
      ref={props.forwardedRef}
      className={styles.target}
      style={inlineStyle}
      tabIndex={getTabIndexValue()}
      role="button"
      onKeyDown={ev => ev.key === 'Enter' && props.onDrop(props.forwardedRef)}
      aria-label={props.ariaLabelDescription || ''}
      aria-pressed={!!props.filledSpot}
    >
      {props.children}
    </div>
  );
};

Target.propTypes = {
  ariaLabelDescription: PropTypes.string,
  children: PropTypes.node,
  forwardedRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  outline: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  divId: PropTypes.string,
  gameStarted: PropTypes.bool,
  filledSpot: PropTypes.bool,
  onDrop: PropTypes.func,
  activityType: PropTypes.string,
  noPieceSelected: PropTypes.bool
};

Target.defaultProps = {
  filledSpot: false,
  gameStarted: true,
  activityType: null
};
